export const AUTH_NOTIFICATION_MESSAGES = {
    NO_DATA_PROVIDER_ASSIGNED:
        'No data provider has been assigned to your account. You are being logged out. Please contact your administrator.',

    USER_NOT_ENTITLED:
        'You do not have access to SUMO. You are being logged out. Please contact the support team to request access.',
};

export const AUTH_NOTIFICATION_DELAYS = {
    LOGOUT_AFTER_WARNING_MS: 6000,
};

export const AUTH_ERROR_CODES = {
    USER_NOT_ENTITLED: 'USER_NOT_ENTITLED',
};

export const AUTH_RESPONSE_HEADERS = {
    SUMO_ERROR: 'X-Sumo-Error',
};